import { render, staticRenderFns } from "./ProductSourcingDetails.vue?vue&type=template&id=539d4873&scoped=true"
import script from "./ProductSourcingDetails.vue?vue&type=script&lang=js"
export * from "./ProductSourcingDetails.vue?vue&type=script&lang=js"
import style0 from "./ProductSourcingDetails.vue?vue&type=style&index=0&id=539d4873&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "539d4873",
  null
  
)

export default component.exports